import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Button from "../../front-end-global-components/components/Button/Button";
import FeatureFlagsFallback from "../../front-end-global-components/components/FeatureFlagsFallback/FeatureFlagsFallback";
import Header from "../../front-end-global-components/components/Header/Header";
import InputBox from "../../front-end-global-components/components/InputBox/InputBox";
import OTPInputBox from "../../front-end-global-components/components/OTPInputBox/OTPInputBox";
import {
  clearAuthCredentials,
  sendOtp,
  verifyOtp
} from "../../redux/authentication/actions";
import { mockAuthVerifyOtp } from "../../redux/mock/actions";
import { reCaptchaVerifier } from "../../services/authentication";
import "./Login.css";

function Login(props) {
  const [loginFormData, setLoginFormData] = useState({
    phoneNumber: "+91",
    OTP: null
  });
  const [counter, setCounter] = useState(null);

  //invisible recaptcha for authentication
  useEffect(() => {
    window.reCaptchaVerifier = reCaptchaVerifier();
  }, []);

  const setOTPValue = (otp) => {
    if (loginFormData.phoneNumber === null) {
    }
    setLoginFormData({
      ...loginFormData,
      OTP: otp
    });
  };

  const loginFormChange = (event) => {
    //To clear auth verification while user trying to change phone number after otp sent
    if (
      event.target.name === "phoneNumber" &&
      props.auth.credentials.verificationId &&
      loginFormData.phoneNumber !== event.target.value
    ) {
      clearAuthCredentials();
    }
    if (event.target.name.includes("otp")) {
      return;
    }
    setLoginFormData({
      ...loginFormData,
      [event.target.name]: event.target.value
    });
  };

  const otpRequestHandler = () => {
    sendOtp(loginFormData.phoneNumber, "login");
    setLoginFormData({ ...loginFormData, show: "otpInput" });
  };

  const otpVerifyHandler = () => {
    if (process.env.REACT_APP_STAGING === "local") {
      mockAuthVerifyOtp("login");
    } else {
      verifyOtp(loginFormData.OTP);
    }
  };

  useEffect(() => {
    if (counter === null) {
      return;
    }

    if (counter <= 0) {
      setCounter(null);
      return;
    }

    const timer = setTimeout(() => {
      setCounter((prev) => (prev > 0 ? prev - 1 : null));
    }, 1000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [counter]);

  useEffect(() => {
    if (props.auth.credentials.verificationId) {
      setCounter(60);
    } else {
      setCounter(null);
    }
    // eslint-disable-next-line
  }, [props.auth.credentials.verificationId]);

  return (
    <div className="inherit-parent-height" data-cy="login-screen">
      <Header hideSupport={true} hideBackButton={true} maxStepperCount={3} />

      {!props.app.featureFlags?.authentication && (
        <FeatureFlagsFallback height="remaining-body-height" />
      )}

      {props.app.featureFlags?.authentication && (
        <form
          data-cy="login-or-signup"
          className="remaining-body-height overflow-x-scroll width-100-percent grey-abstract-background-image flex-place-children-page-center"
          onChange={(event) => {
            loginFormChange(event);
          }}
          onSubmit={(event) => {
            event.preventDefault();
            if (props.auth.credentials.verificationId) {
              otpVerifyHandler();
            } else {
              otpRequestHandler();
            }
          }}
        >
          <div className="padding-larger inherit-parent-width flex-grow-1">
            <h1 className="font-weight-normal font-family-gilroy-medium font-size-small font-color-secondary inherit-parent-width text-align-center">
              PATIENT LOGIN
            </h1>
            <InputBox
              className="inherit-parent-width border-radius-default margin-vertical-large"
              name="phoneNumber"
              label="Phone Number"
              type="tel"
              autoFocus={true}
              autoComplete="off"
              value={loginFormData.phoneNumber}
              required
              data-cy="LOGIN-SCREEN-PHONE-NUMBER-FIELD"
            />
            {props.auth.credentials.verificationId ? (
              <>
                <OTPInputBox
                  name="otp"
                  setValue={setOTPValue}
                  className="margin-bottom-large"
                  required
                />
                <div className="display-flex flex-justify-content-space-between font-size-medium margin-bottom-larger">
                  {counter && typeof counter === "number" ? (
                    <div>
                      {`00:${counter.toString().padStart(2, "0")} seconds`}
                    </div>
                  ) : (
                    <div />
                  )}
                  <div
                    className={`${
                      typeof counter === "number"
                        ? "font-color-tertiary"
                        : "font-color-primary"
                    }`}
                    onClick={() => {
                      if (typeof counter === "number") {
                        return;
                      }
                      otpRequestHandler();
                    }}
                  >
                    Resend OTP
                  </div>
                </div>
              </>
            ) : null}
          </div>
          <div className="padding-larger inherit-parent-width">
            <Button
              data-cy={
                props.auth.loading === true
                  ? "LOGIN-LOADING-BUTTON"
                  : "LOGIN-BUTTON"
              }
              loading={props.auth.loading}
              type="submit"
              text={
                props.auth.credentials.verificationId ? "Login" : "Continue"
              }
              boxShadow={false}
              disabled={
                props.auth.credentials.verificationId
                  ? !(
                      typeof loginFormData.OTP === "string" &&
                      loginFormData.OTP.length === 6
                    )
                  : loginFormData.phoneNumber?.length !== 13
              }
            />
          </div>
        </form>
      )}
      <div id="recaptcha-placeholder" />
    </div>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  app: state.app
});

export default connect(mapStateToProps)(Login);
